import axiosInstance from './axios.service';

export async function getPersonalsName() {
  const url = `/operator/personal/list`;
  try {
    const response = await axiosInstance.get(url);
    const list = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];
    return list.map((item) => {
      return {
        id: item.id,
        firstName: item.firstName,
        lastName: item.lastName,
        point: item.point ?? item.points ?? null,
      };
    });
  } catch (error) {
    console.error('Error fetching personals:', error);
    return { status: 400, message: error };
  }
}
